import { useDiagramGlobals } from 'hooks/use-general-globals';

/**
 * The engineering support company (general.supportTeam), served via the
 * SWR-backed public globals endpoint.
 */
const useSupportCompany = () => {
    const { data, ...swr } = useDiagramGlobals();

    return {
        ...swr,
        company: data?.supportTeam,
    };
};

export { useSupportCompany };
